// client/src/pages/adminpages/RejectedResultsPage.js
import React from 'react';
import AdminLayout from '../../components/admin/layout/AdminLayout';
import RejectedResultsList from '../../components/admin/result/RejectedResultsList';

function RejectedResultsPage() {
  return (
    <AdminLayout title="결과물 거절 건 관리">
      <RejectedResultsList />
    </AdminLayout>
  );
}

export default RejectedResultsPage;
